module.exports = __webpack_public_path__ + "static/cariplo-1e36bf709943776431a7578bcc5066a4.png";